module.exports = __webpack_public_path__ + "img/6-Final-Gif.6beb23b7.gif";